import { toast } from 'react-hot-toast';
import api from '../../services/api';
import { generarPDF as generarRemitoPDFPremium } from './index.js';
import { trabajoHecho } from './pdfShared';
import { mesTexto } from '../../components/trabajos/ProximoMantenimiento';

// El PDF de un trabajo (28-oct-2026): salió de Trabajos para usarlo también desde la ficha de la visita del
// Inicio (antes había que ir a "Ver en Trabajos" para bajarlo).
export async function pdfDeTrabajo(s, { sinPrecios = false, soloResumen = false, firmas = null } = {}) {
    const t = toast.loading('Generando PDF…');
    // Mientras el trabajo no está hecho (presupuesto, agendado, en curso) el PDF es un
    // PRESUPUESTO; recién hecho pasa a "Trabajo realizado" (9-oct-2026: salía al revés)
    const ppto = !trabajoHecho(s);
    // Trabajo sin precio (cliente con tarifa mensual): sin Neto / IVA / Total en $0 (22-oct-2026)
    if (!ppto && !(Number(s.montoFinal) > 0) && (s.items || []).every(it => !(parseFloat(it.costo) > 0))) sinPrecios = true;
    // Firmas guardadas en el trabajo (16-oct-2026)
    if (!firmas && !ppto && s.tieneFirmas) {
        try {
            const r = await api.get(`/servicios/${s.id}/firmas`);
            if (r.data?.firmaCliente || r.data?.firmaTecnico) firmas = { incluirFirmas: true, ...r.data };
        } catch { /* sin firmas */ }
    }
    try {
        await generarRemitoPDFPremium({
            tipo: ppto && s.servicioTipo === 'VENTA' ? 'PRESUPUESTO_VENTA' : undefined,
            esPresupuesto: ppto, servicioId: s.id,
            nroDocumentoExistente: s.nroDocumento || localStorage.getItem(`pdf_nro_${s.id}`) || null,
            cliente: { nombre: s.clienteNombre, telefono: s.clienteTelefono, email: s.clienteEmail, cuilDni: s.clienteDni, condicionIva: s.clienteCondicionIva },
            sede: { nombreSede: s.sedeNombre, direccion: s.sedeDireccion, piso: s.sedePiso, depto: s.sedeDepto },
            tecnico: s.items?.[0]?.tecnico || s.usuarioNombre || 'Técnico',
            ticketItems: (s.items || []).map(it => ({ ...it, totalCalculado: parseFloat(it.costo) || 0, trabajo: it.trabajoRealizado || '' })),
            fechaServicio: s.fecha, descuentoPorcentaje: s.descuentoPorcentaje || 0,
            descuentoAlcance: s.descuentoAlcance || 'TOTAL', totales: s.totales || null,
            leyenda: s.observaciones || '', sinPrecios, soloResumen,
            incluirFirmas: !!firmas?.incluirFirmas, firmaTecnico: firmas?.firmaTecnico || null, firmaCliente: firmas?.firmaCliente || null, aclaracionCliente: firmas?.aclaracionCliente || '',
            fotosTrabajo: ppto ? [] : (s.fotosTrabajo || []),
            modalidadCobro: s.modalidadCobro || null, montoFinal: s.montoFinal ?? null,
            proximoMantenimiento: ppto ? null : mesTexto(s.proximoMantenimiento),
        });
        toast.success('PDF generado', { id: t });
    } catch { toast.error('No se pudo generar el PDF', { id: t }); }
}
